/* eslint-disable react/no-array-index-key */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useRef, useState } from 'react';

import MultiProjectron from '../icons/MultiProjectron';

import styles from '../../../styles/partials/projectron.module.css';

const propTypes = {
    id: PropTypes.string,
    films: PropTypes.arrayOf(PropTypes.shape({})),
    className: PropTypes.string,
};

function Projectron({ id = null, films = null, className }) {
    const [image, setImage] = useState(null);
    const [open, setOpen] = useState(true);
    const indexRef = useRef(0);

    const onRest = useCallback(
        (opn) => {
            if (!opn) {
                setOpen(true);
            }
        },
        [setOpen],
    );

    const onNextField = useCallback(() => {
        if (films === null) {
            return;
        }
        const film = films[indexRef.current] || null;
        const { image: itemImage = null } = film || {};
        if (indexRef.current === films.length - 1) {
            indexRef.current = 0;
        } else {
            indexRef.current += 1;
        }
        setOpen(!open);
        setTimeout(() => setImage(itemImage), 500);
    }, [films, setImage, setOpen]);

    // Initial
    useEffect(() => {
        onNextField();
        const intervalId = setInterval(() => onNextField(), 3000);
        return () => clearInterval(intervalId);
    }, [onNextField, films]);

    return (
        <div
            id={id}
            className={classNames([styles.container, { [className]: className !== null }])}
        >
            <MultiProjectron
                className={styles.projectron}
                image={image}
                open={open}
                onRest={onRest}
            />
        </div>
    );
}

Projectron.propTypes = propTypes;

export default Projectron;
